/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { GridLookup3D } from '../../../../mol-math/geometry.js';
import { SortedArray } from '../../../../mol-data/int.js';
import { getBoundary } from '../../../../mol-math/geometry/boundary.js';
export function calcUnitProteinTraceLookup3D(unit, unitProteinResidues) {
    const { x, y, z } = unit.model.atomicConformation;
    const { traceElementIndex } = unit.model.atomicHierarchy.derived.residue;
    const indices = new Uint32Array(unitProteinResidues.length);
    for (let i = 0, il = unitProteinResidues.length; i < il; ++i) {
        indices[i] = traceElementIndex[unitProteinResidues[i]];
    }
    const position = { x, y, z, indices: SortedArray.ofSortedArray(indices) };
    return GridLookup3D(position, getBoundary(position));
}
